import "./App.css";
import {Link, useNavigate} from "react-router-dom";
import {useState} from "react";
import {
    Button,
    Card,
    Dialog,
    DialogBody,
    DialogFooter,
    DialogHeader,
    Input,
    Typography
} from "@material-tailwind/react";
import Footer from "./footer";

function App() {
    const navigate = useNavigate();
    const [loginError, setLoginError] = useState("");
    const [openDialog, setOpenDialog] = useState(false);

    const googleLogin = () => {
        window.location.href = process.env.REACT_APP_API_URL + "/oauth2/authorization/google";
    };

    const handleOpenDialog = () => setOpenDialog(!openDialog);

    const onSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        formData.append("username", formData.get("username"));
        formData.append("password", formData.get("password"));

        fetch(process.env.REACT_APP_API_URL + "/login", {
            method: "POST",
            body: formData,
            crossDomain: true,
        })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        setLoginError("Username or password incorrect");
                    }
                } else {
                    const expires = new Date();
                    expires.setTime(expires.getTime() + 20 * 60 * 1100);
                    const authorization = response.headers.get("Authorization").split(" ")[1];
                    document.cookie = `Authorization=${authorization};expires=${expires.toUTCString()};path=/`;
                    navigate("/services");
                }
            })
            .catch((err) => err);
    };

    return (

        <div className="h-screen bg-gradient-to-br bg-blue-50 flex flex-col overflow-hidden">
            {/* Header Section with Brand and Main Content */}
            <div className="flex-1 flex items-center justify-center px-4 py-6 overflow-y-auto">
                <div className="w-full max-w-md">
                    {/* Brand Header */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <Typography variant="h3" className="text-gray-900 font-bold mb-2">
                            No1. Jimmy Auto
                        </Typography>
                        {/*<Typography variant="small" className="text-gray-600 font-medium">*/}

                        {/*<Typography variant="small" className="text-gray-600 font-medium">*/}
                        {/*    Professional Auto Service Platform*/}
                        {/*</Typography>*/}
                    </div>

                    {/* Login Card */}
                    <Card className="p-5 shadow-xl border-0 backdrop-blur-sm bg-white/90">
                        <form onSubmit={onSubmit} className="space-y-6">
                            <div className="space-y-5">
                                <div>
                                    <Typography variant="small" className="font-semibold text-gray-700 mb-2">
                                        Email Address
                                    </Typography>
                                    <Input
                                        maxLength="50"
                                        name="username"
                                        size="lg"
                                        placeholder="Enter your email"
                                        className="!border-gray-300 focus:!border-blue-500 rounded-lg"
                                        labelProps={{
                                            className: "before:content-none after:content-none",
                                        }}
                                        containerProps={{
                                            className: "min-w-0"
                                        }}
                                    />
                                </div>

                                <div>
                                    <Typography variant="small" className="font-semibold text-gray-700 mb-2">
                                        Password
                                    </Typography>
                                    <Input
                                        maxLength="50"
                                        type="password"
                                        name="password"
                                        size="lg"
                                        placeholder="Enter your password"
                                        className="!border-gray-300 focus:!border-blue-500 rounded-lg"
                                        labelProps={{
                                            className: "before:content-none after:content-none",
                                        }}
                                        containerProps={{
                                            className: "min-w-0"
                                        }}
                                    />
                                </div>
                            </div>

                            {loginError && (
                                <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                                    <Typography variant="small" className="text-red-600 font-medium">
                                        {loginError}
                                    </Typography>
                                </div>
                            )}

                            <Button
                                type="submit"
                                className="w-full bg-blue-600 hover:bg-blue-700 rounded-lg py-3 font-semibold text-base transition-all duration-200"
                                size="lg"
                            >
                                Sign In
                            </Button>

                            {/* Divider */}
                            <div className="relative flex items-center py-2">
                                <div className="flex-grow border-t border-gray-200"></div>
                                <span className="flex-shrink mx-4 text-sm text-gray-500 font-medium">or continue with</span>
                                <div className="flex-grow border-t border-gray-200"></div>
                            </div>

                            {/* Google Login */}
                            <Button
                                onClick={googleLogin}
                                variant="outlined"
                                className="w-full border-gray-300 hover:bg-gray-50 rounded-lg py-3 font-semibold text-base transition-all duration-200 flex items-center justify-center gap-3"
                                size="lg"
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 17 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_1156_824)">
                                        <path
                                            d="M16.3442 8.18429C16.3442 7.64047 16.3001 7.09371 16.206 6.55872H8.66016V9.63937H12.9813C12.802 10.6329 12.2258 11.5119 11.3822 12.0704V14.0693H13.9602C15.4741 12.6759 16.3442 10.6182 16.3442 8.18429Z"
                                            fill="#4285F4"
                                        />
                                        <path
                                            d="M8.65974 16.0006C10.8174 16.0006 12.637 15.2922 13.9627 14.0693L11.3847 12.0704C10.6675 12.5584 9.7415 12.8347 8.66268 12.8347C6.5756 12.8347 4.80598 11.4266 4.17104 9.53357H1.51074V11.5942C2.86882 14.2956 5.63494 16.0006 8.65974 16.0006Z"
                                            fill="#34A853"
                                        />
                                        <path
                                            d="M4.16852 9.53356C3.83341 8.53999 3.83341 7.46411 4.16852 6.47054V4.40991H1.51116C0.376489 6.67043 0.376489 9.33367 1.51116 11.5942L4.16852 9.53356Z"
                                            fill="#FBBC04"
                                        />
                                        <path
                                            d="M8.65974 3.16644C9.80029 3.1488 10.9026 3.57798 11.7286 4.36578L14.0127 2.08174C12.5664 0.72367 10.6469 -0.0229773 8.65974 0.000539111C5.63494 0.000539111 2.86882 1.70548 1.51074 4.40987L4.1681 6.4705C4.8001 4.57449 6.57266 3.16644 8.65974 3.16644Z"
                                            fill="#EA4335"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1156_824">
                                            <rect
                                                width="16"
                                                height="16"
                                                fill="white"
                                                transform="translate(0.5)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span className="text-gray-700">Continue with Google</span>
                            </Button>

                            {/* Sign Up Link */}
                            <div className="text-center pt-2">
                                <Typography className="text-gray-600">
                                    New to Jimmy Auto?{" "}
                                    <Link to="/signup" className="text-blue-600 hover:text-blue-700 font-semibold hover:underline transition-colors duration-200">
                                        Create an account
                                    </Link>
                                </Typography>
                            </div>

                            {/* Privacy Policy */}
                            <div className="pt-2 border-t border-gray-100">
                                <Typography variant="small" className="text-gray-500 text-center leading-relaxed">
                                    By signing in, you agree to our{" "}
                                    <span
                                        className="text-blue-600 hover:text-blue-700 cursor-pointer hover:underline font-medium transition-colors duration-200"
                                        onClick={handleOpenDialog}
                                    >
                                        Privacy Policy
                                    </span>
                                </Typography>
                            </div>
                        </form>
                    </Card>
                </div>
            </div>
            {/* Footer moved inside the main container */}
            <Footer />

            {/* Privacy Policy Dialog */}
            <Dialog open={openDialog} handler={handleOpenDialog} size="md" className="rounded-2xl shadow-2xl">
                <DialogHeader className="text-xl font-bold text-gray-800 border-b border-gray-100 pb-4">
                    Privacy Policy
                </DialogHeader>
                <DialogBody divider className="h-[50vh] overflow-y-auto text-gray-700 text-sm leading-relaxed space-y-4">
                    <Typography variant="paragraph" className="text-gray-600">
                        This Privacy Policy outlines how our platform, used by JimmyAuto and other auto service providers,
                        collects, uses, and safeguards your personal information when you interact with our services.
                    </Typography>

                    <div>
                        <Typography variant="h6" className="text-gray-800 font-semibold mb-3">
                            Information We Collect
                        </Typography>
                        <ul className="list-disc list-inside space-y-2 text-gray-600">
                            <li>Information you provide directly (e.g., contact details, booking data)</li>
                            <li>Information collected automatically (e.g., device/browser data, usage logs)</li>
                            <li>Information from third-party integrations, if authorized</li>
                        </ul>
                    </div>

                    <div>
                        <Typography variant="h6" className="text-gray-800 font-semibold mb-3">
                            How We Use Your Information
                        </Typography>
                        <ul className="list-disc list-inside space-y-2 text-gray-600">
                            <li>To operate and improve our software platform</li>
                            <li>To provide support and personalized service to JimmyAuto and similar users</li>
                            <li>To communicate service updates or important notifications</li>
                            <li>To comply with legal obligations</li>
                        </ul>
                    </div>

                    <div>
                        <Typography variant="h6" className="text-gray-800 font-semibold mb-3">
                            Sharing of Information
                        </Typography>
                        <ul className="list-disc list-inside space-y-2 text-gray-600">
                            <li>With trusted service providers and subcontractors under confidentiality agreements</li>
                            <li>With legal or regulatory authorities when required by applicable laws</li>
                            <li>Never sold or shared for advertising purposes without explicit consent</li>
                        </ul>
                    </div>

                    <Typography variant="paragraph" className="text-gray-600 bg-gray-50 p-4 rounded-lg">
                        By using our services, you consent to the collection and use of information as described in this policy.
                        This policy may be updated periodically. We encourage you to review it regularly.
                    </Typography>
                </DialogBody>
                <DialogFooter className="border-t border-gray-100 pt-4">
                    <Button
                        variant="filled"
                        color="blue"
                        onClick={handleOpenDialog}
                        className="rounded-lg px-6"
                    >
                        Got it
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
}

export default App;
